var render = function render(){var _vm=this,_c=_vm._self._c;return _c('checkin-stepper',{attrs:{"step":8,"title":{ text: 'You\'re', strongText: 'done!' }},on:{"next":_vm.next}})
}
var staticRenderFns = []

export { render, staticRenderFns }